module.exports = __webpack_public_path__ + "img/Slagboom-persoon.7a4fd191.svg";